
import { useVideoPopup } from '../hooks/useState'
import gsap from 'gsap'
import { page as initRubigol3D } from "../pages/rubigol"

export class VideoController {
  public videoWrapper: HTMLElement | null
  public videoContent: HTMLElement | null
  public timeline


  constructor() {
    this.videoWrapper = document.querySelector('.ar__video_overlay')
    this.videoContent = document.querySelector(".ar__popup--content")

    this.timeline = gsap.timeline({
      defaults: {
        duration: 0.65
      }
    })
  }
  async open(id: string) {
    
    switch (id) {

      case "rubigol":
        window.dataLayer.push({
          'event': 'GAEvent',
          'event_category': 'Content',
          'event_action': 'Content',
          'event_label': 'See Popup Video',
          'interaction': 'true',
          'component_name': 'Modo_Carrera_Popup_video',
          'element_text': 'Video de bienvenida',
        });
        break;
      default:
        //
        break;
    }

    if (!this.videoContent) return

    this.timeline.to(this.videoWrapper, {
      opacity: 1,
      ease: 'power1.in',
      onStart() {
        this.targets()[0].style.display = 'block'
        this.targets()[0].style.pointerEvents = 'all'
      }
    })

  }

  close() {
    // console.log("close")
    this.timeline.to(this.videoWrapper, {
      opacity: 0,
      ease: 'power1.out',
      top: '-=200',
      onComplete() {
        // this.targets()[0].style.display = 'none'
        // this.targets()[0].style.pointerEvents = 'none'
        this.targets()[0].remove()
      }
    })

  }
}
